import React from 'react';
import PropTypes from 'prop-types';
import { useApolloClient } from '@apollo/client'; // Hook zamiast HOC
import FilterOtherType from './FilterTypes/FilterOtherType';
import FilterRangeType from './FilterTypes/FilterRangeType';

const FilterItem = (props) => {
    const client = useApolloClient(); // Dostęp do klienta Apollo

    // Przekazanie klienta Apollo do podkomponentów razem z innymi propsami
    const filterProps = { ...props, client };

    if (props.type === 'FilterRangeTypeInput') {
        return <FilterRangeType {...filterProps} />;
    }
    return <FilterOtherType {...filterProps} />;
};

FilterItem.propTypes = {
    type: PropTypes.string.isRequired,
    // Dodaj inne propsy, jeśli są używane w FilterRangeType/FilterOtherType
};

export default FilterItem;